import { useSchemaOrg } from '@unhead/schema-org/react';

/**
 * @type {import('$types/components/partials/home').HomeSchema}
 */

const HomeSchema = ({ page, url, socialLinks, footer }) => {
    const schemas = [];

    // RealEstateAgent Schema
    /** @type {Record<string, any>} */
    const realEstateAgentSchema = {
        '@type': 'RealEstateAgent',
        name: 'Beauchamp Estates',
        url: url,
    };

    // Add description if available
    if (page?.metaDescription) {
        realEstateAgentSchema.description = page.metaDescription;
    }

    // Add logo image
    if (footer?.logo?.src) {
        realEstateAgentSchema.image = footer.logo.src;
    }

    if (page?.seoTelephone) {
        realEstateAgentSchema.telephone = page.seoTelephone;
    }

    if (page?.seoEmail) {
        realEstateAgentSchema.email = page.seoEmail;
    }

    if (page?.seoAddress) {
        realEstateAgentSchema.address = {
            '@type': 'PostalAddress',
            streetAddress: page.seoAddress,
        };
    }

    // Add social media links
    if (socialLinks?.length > 0) {
        realEstateAgentSchema.sameAs = socialLinks
            .map(social => social.link?.href)
            .filter(Boolean);
    }

    // Add services catalog
    realEstateAgentSchema.hasOfferCatalog = {
        '@type': 'OfferCatalog',
        name: 'Real Estate Services',
        itemListElement: [
            {
                '@type': 'Offer',
                itemOffered: {
                    '@type': 'Service',
                    name: 'Property Sales',
                    description: 'Buying and selling properties'
                }
            },
            {
                '@type': 'Offer',
                itemOffered: {
                    '@type': 'Service',
                    name: 'Property Rentals',
                    description: 'Renting properties'
                }
            },
            {
                '@type': 'Offer',
                itemOffered: {
                    '@type': 'Service',
                    name: 'Property Valuations',
                    description: 'Property valuation services'
                }
            }
        ]
    };

    schemas.push(realEstateAgentSchema);

    // WebSite Schema
    /** @type {Record<string, any>} */
    const websiteSchema = {
        '@type': 'WebSite',
        name: 'Beauchamp Estates',
        url: url,
    };

    // Add search action for site search
    websiteSchema.potentialAction = {
        '@type': 'SearchAction',
        target: {
            '@type': 'EntryPoint',
            urlTemplate: `${url?.replace(/\/$/, '')}/search?q={search_term_string}`
        },
        'query-input': 'required name=search_term_string'
    };

    schemas.push(websiteSchema);

    useSchemaOrg(page ? schemas : [], { tagPosition: 'head' });

    return null;
};

export default HomeSchema;
